module.exports = __webpack_public_path__ + "img/erosion_al.34b2562f.svg";